import { imsAuthService } from "../../authentication/shared/ims-auth-service";

export async function fetchWithAuth(
  url: string,
  init: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(init.headers);
  Object.entries(imsAuthService.getAuthHeaders()).forEach(([name, value]) => {
    headers.set(name, value);
  });
  headers.set("X-Requested-With", "XMLHttpRequest");

  const response = await fetch(url, { ...init, headers, credentials: "include" });
  if (response.status === 401) {
    imsAuthService.handleUnauthorized();
  }
  return response;
}
